import { PaymentStatus as t } from "./models/PaymentStatus.js";
import { RefType as c } from "./models/RefType.js";
const f = (o) => {
  let e = "";
  return Object.keys(o).forEach((n, r) => {
    const i = o[n];
    i !== void 0 && (e += `${r > 0 ? "&" : "?"}${n}=${encodeURIComponent(i)}`);
  }), e;
}, m = (o, e, n, r) => {
  (o == null ? void 0 : o.status) === t.CapturedFailed && !n && (window.location.href = r || (e === c.Subscription ? `${window.location.origin}/subscription-confirmation/${o.refId}` : `${window.location.origin}/order/${o.refId}`));
}, p = f;
export {
  p as default,
  m as redirectOnCancelPayment
};
//# sourceMappingURL=utils.js.map
